import HttpClient from "libs/utils/HttpClient";

class AuthService {
  login = async (code, redirect_uri) => {
    try {
      const response = await HttpClient.post("/api/users/online/login", {
        code,
        redirect_uri,
      });

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  loginOffline = async (username, password) => {
    try {
      const response = await HttpClient.post("/api/users/offline/login", {
        username,
        password,
      });

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  loginNew = async (data) => {
    try {
      const response = await HttpClient.post("/api/users/login", data);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  ForgotPassword = async (data) => {
    try {
      const response = await HttpClient.post("/api/users/forgotsendmail", data);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
  ForgotPasswordCheck = async (data) => {
    try {
      const response = await HttpClient.post(
        "/api/users/forgotpassword/valid",
        data
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  Register = async (data) => {
    try {
      const response = await HttpClient.post("/api/users/register", data);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  refreshToken = async (refreshToken) => {
    try {
      const response = await HttpClient.post("/api/users/online/refeshtoken", {
        refreshToken,
      });
      console.log("response => ", response);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  getUser = async () => {
    try {
      const response = await HttpClient.post("/api/users/user");

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
}

export default new AuthService();
